import { useEditor, EditorContent } from '@tiptap/react'
import { useEffect } from 'react'
import StarterKit from '@tiptap/starter-kit'
import { Markdown } from 'tiptap-markdown'
import Mention from '@tiptap/extension-mention'
import Heading from '@tiptap/extension-heading'
import type MarkdownIt from "markdown-it"
import { addMentionMarkdownPlugin } from './utils/markdownPlugin'
import styles from './Editor.module.scss'

export function ReadOnlyMarkdown({ content }: { content: string }) {
    const editor = useEditor({
        extensions: [
            StarterKit.configure({
                link: {
                    openOnClick: false,
                },
            }),
            Markdown.configure({
                html: true,
                transformPastedText: true,
                transformCopiedText: true,
                breaks: true,
            }),
            Mention.extend({
                addStorage() {
                    return {
                        markdown: {
                            parse: {
                                setup(markdownit: MarkdownIt) {
                                    addMentionMarkdownPlugin(markdownit)
                                },
                            },
                        },
                    }
                },
            }).configure({
                HTMLAttributes: {
                    class: 'mention',
                },
                renderLabel({ node }) {
                    return `@${node.attrs.label ?? node.attrs.id}`
                },
            }),
        ],
        editable: false,
        editorProps: {
            attributes: {
                class: 'prose prose-sm',
                dir: 'auto',
            },
        },
    })

    useEffect(() => {
        if (editor && content !== undefined && content !== null) {
            editor.commands.setContent(content)
        }
    }, [editor, content])

    if (!editor) return null

    return <EditorContent editor={editor} />
}
